<template>
  <div class="seomain">
    <st-header
      title="确认付款"
      :back-able="true"
    >
    </st-header>
    <div class="st-form-content">
      <st-form ref="form">
        <!-- <div class="st-form-title">基本信息</div> -->
        <div class="st-form-group">

          <van-cell-group inset>
            <st-form-item key="type" label="付款方式" prop="type" :required="true">
              <st-select
                v-model="formData.type"
								:defText="formData.type"
                name="付款方式"
                placeholder="请选择付款方式"
                :options="$option['getModelConf']('FinancePaymentOrder', 'type')"
								:clearable="true"
								:filterable="false"
              >
              </st-select>
            </st-form-item>
						
						<st-form-item key="payer" label="付款人" prop="payer" :required="true">
						  <st-select
						    v-model="formData.payer"
						    name="付款人"
						    placeholder="请选择付款人"
						    :options="$option['getAdmins']"
								:custom-params="{'type': 'payment'}"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="corporation_id" label="付款账户" prop="corporation_id" :required="true">
						  <st-select
						    v-model="formData.corporation_id"
								:defText="formData.corporation_name"
						    name="收款账户"
						    placeholder="请选择收款账户"
						    :options="$option['getCorporation']"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="payment_account" label="付款账号" prop="payment_account">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.payment_account"
						    name="付款账号"
								placeholder="请输入付款账号"
						    label=""
						  />
						</st-form-item>
						
						<st-form-item key="payment_bank" label="付款银行" prop="payment_bank">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.payment_bank"
						    name="付款银行"
								placeholder="请输入付款银行"
						    label=""
						  />
						</st-form-item>
						
						<st-form-item key="currency" label="币种" prop="currency">
						  <st-select
						    v-model="formData.currency"
						    name="币种"
						    placeholder="请选择币种"
						    :options="$option['getCurrency']"
								:filterable="false"
								disabled
								:readonly="true"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="amount" label="付款金额" prop="amount">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.amount"
						    name="付款金额"
						    label=""
								disabled
						  />
						</st-form-item>
						
						<st-form-item key="collection_cecompany_name" label="收款公司" prop="collection_cecompany_name">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.collection_cecompany_name"
						    name="收款公司"
						    label=""
								disabled
						  />
						</st-form-item>
			
					<st-form-item key="account_name" label="收款账号名称" prop="account_name">
					  <van-field
					    class="st-form-item-input"
					    v-model="formData.account_name"
					    name="收款账号名称"
					    label=""
							disabled
					  />
					</st-form-item>
					
					<st-form-item key="collection_account" label="收款账号" prop="collection_account">
					  <van-field
					    class="st-form-item-input"
					    v-model="formData.collection_account"
					    name="收款账号"
					    label=""
							disabled
					  />
					</st-form-item>
						
						<st-form-item key="receipt_images" label="付款回执" prop="receipt_images" :required="true">
						  <st-file-upload
						    v-model="formData['receipt_images']"
						  >
						  </st-file-upload>
						</st-form-item>
          </van-cell-group>
        </div>
        
        <div style="margin: 16px;" class="form-submit-button">
          <van-button round block type="primary"  @click="onSubmit">
            提交
          </van-button>
        </div>
      </st-form>
    </div>
    
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import StHeader from "@/components/layout/Header.vue";
import StForm from "@/components/form.vue";
import StFormItem from "@/components/formItem.vue";
import formConf from "./conf/form.js";

export default {
  name: 'stSalesAdd',
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate
  },
  props: {},
  data() {
    return {
      formRule: {},
      formData: {
				currency: 'CNY',
				amount: "",
				receipt_images: []
      }, 
      loading: false,
    };
  },
  watch: {},
	computed: {},
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "确认付款" });
    });
  },
  mounted() {},

  methods: {
    init() {
			let id = parseInt(this.$route.query.id);
			this.formData.id = isNaN(id) ? 0 : id;
			this.getUpdateData();
		},
		// 获取编辑需要显示的数据
		getUpdateData() {
			if (this.formData.id) {
				this.$post(`${this.$api.stPayOrderEditInfo}`, {id: this.formData.id}).then((res) => {
					let data = res.data;
					data.type = data.type * 1;
					data.receipt_images = [];
					this.formData = data;
				}).catch((err) => {
					window.history.go(-1);
					console.log('payorder/pay', err);
				});
			} else {}
		},

    // 提交表单
    onSubmit() {
     this.$refs.form.validater.valid((isValid, lastError) => {
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastError);
        }
      });
			
      let formData = JSON.parse(JSON.stringify(this.formData));
			formData['receipt_images'] = formData['receipt_images'].map((item) => { return item.url; }).join(',');
			this.pay(formData);
      
    },
		
		pay(formData) {
			this.$post(this.$api.stPayOrderPay, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '付款异常');
			  } else {
			    this.$toast.success("付款成功");
			    this.$router.replace(`/payorder/list`);
			  }
			});
		},
  },
};
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;
	form {
		overflow: hidden;
	}
	
  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
		padding-bottom: 16px;
		border-radius: 5px;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      margin-top: 12px;
    }

  }

}

</style>
